import { render, staticRenderFns } from "./QuotesTable.vue?vue&type=template&id=2b3b1670&"
import script from "./QuotesTable.vue?vue&type=script&lang=ts&"
export * from "./QuotesTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports